const reasons = [
  {
    icon: "ri-focus-3-line",
    title: "Strategic, Results-Driven",
    desc: "Targeted legal strategies focused on measurable, favorable outcomes for every client matter we handle.",
  },
  {
    icon: "ri-chat-check-line",
    title: "Clear Communication",
    desc: "Complex legal matters explained plainly. You always know exactly where your case stands and what comes next.",
  },
  {
    icon: "ri-speed-line",
    title: "Efficient Case Handling",
    desc: "Decades of specialized experience allow us to navigate even the most complex matters with precision and speed.",
  },
  {
    icon: "ri-user-star-line",
    title: "Client Outcomes First",
    desc: "Every decision and action is anchored in what's best for your specific situation and long-term interests.",
  },
];

export default function SectionWhyChooseUs() {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left content */}
          <div>
            <span className="block text-[11px] tracking-[0.25em] text-[#C9A961] uppercase font-inter font-medium mb-4">
              Why Choose Us
            </span>
            <h2 className="text-4xl lg:text-5xl font-playfair font-bold text-[#0A1628] leading-tight mb-6">
              A Firm Built on<br />
              <span className="italic text-[#C9A961]">Integrity &amp; Results</span>
            </h2>
            <p className="text-slate-600 font-inter text-base leading-relaxed mb-8">
              Since 1986, Alice G. Gosfield &amp; Associates has provided strategic health law counsel
              that physicians, health systems, and organizations rely on. Our boutique structure ensures
              senior partner involvement on every matter — never delegated to junior associates.
            </p>

            {/* Stats row */}
            <div className="flex items-center gap-8 mb-10">
              <div className="text-center">
                <div className="text-3xl font-playfair font-bold text-[#0A1628]">40+</div>
                <div className="text-xs text-slate-500 font-inter mt-0.5">Years Practice</div>
              </div>
              <div className="w-px h-12 bg-slate-200" />
              <div className="text-center">
                <div className="text-3xl font-playfair font-bold text-[#0A1628]">50</div>
                <div className="text-xs text-slate-500 font-inter mt-0.5">States Served</div>
              </div>
              <div className="w-px h-12 bg-slate-200" />
              <div className="text-center">
                <div className="text-3xl font-playfair font-bold text-[#0A1628]">Top 5</div>
                <div className="text-xs text-slate-500 font-inter mt-0.5">Law Firm 2024</div>
              </div>
            </div>

            {/* Attorney card */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-[#F8F7F4] border border-slate-100">
              <img
                src="https://public.readdy.ai/ai/img_res/2029f402de21c3521606eaaf31b8e7e7.jpg"
                alt="Alice G. Gosfield, Founding Partner"
                className="w-16 h-16 rounded-full object-cover object-top flex-shrink-0"
              />
              <div>
                <div className="text-sm font-playfair font-bold text-[#0A1628]">Alice G. Gosfield, Esq.</div>
                <div className="text-xs text-[#C9A961] font-inter font-medium mt-0.5">
                  Founding Partner &mdash; 40+ Years Health Law
                </div>
                <div className="text-xs text-slate-500 font-inter mt-1">
                  &ldquo;We treat every client matter with the strategic care it deserves.&rdquo;
                </div>
              </div>
            </div>
          </div>

          {/* Right — feature grid + image */}
          <div className="flex flex-col gap-5">
            <div className="rounded-xl overflow-hidden h-52 relative">
              <img
                src="https://readdy.ai/api/search-image?query=prestigious%20dark%20wood%20law%20library%20interior%20with%20floor%20to%20ceiling%20bookshelves%20filled%20with%20legal%20volumes%2C%20warm%20amber%20lamp%20lighting%20casting%20a%20golden%20glow%2C%20leather%20bound%20books%2C%20sophisticated%20mahogany%20desk%2C%20Philadelphia%20law%20firm%20atmosphere%2C%20editorial%20photography%20with%20strong%20depth%20of%20field&width=700&height=350&seq=wcu001&orientation=landscape"
                alt="Law firm office interior"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/50 to-transparent" />
              <div className="absolute bottom-4 left-5 right-5">
                <p className="text-white font-playfair italic text-base leading-snug">
                  &ldquo;Specialized counsel you can trust — not generalists with competing priorities.&rdquo;
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {reasons.map((item, i) => (
                <div
                  key={i}
                  className="p-5 rounded-lg bg-[#F8F7F4] border border-slate-100 hover:border-[#C9A961]/40 transition-all duration-300"
                >
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#0A1628] mb-3">
                    <i className={`${item.icon} text-[#C9A961] text-base`} />
                  </span>
                  <h3 className="text-xs font-inter font-bold text-[#0A1628] mb-1.5">{item.title}</h3>
                  <p className="text-slate-500 text-xs font-inter leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
